export enum TrackingEventName {
    ACTIVATION_MAIL_RESENT = 'Email d’activation renvoyé',
    APPLICATION_CREATED = 'Candidature créée',
    CONTACT_CREATED = 'Contact crée',
    EVENT_CREATED = 'Entretien crée',
    PAGE_VIEW = 'Page vue',
    SIGN_UP_REQUESTED = 'Inscription demandée',
    TASK_CREATED = 'Tâche créée',
}

export interface EventProps {
    name: TrackingEventName;
    params: Record<string, unknown>;
}
